import { createSelector } from '@reduxjs/toolkit';
import { ReduxStore } from '~/behaviors/types/redux.types';

/**
 * When converting to TypeScript:
 * import type { UserPermissions } from '~/interfaces/permission.interface';
 * const selectPermissions = () => (state: RootState): UserPermissions => state.permissions;
 */
const selectPermissions = () => (state: ReduxStore) => state.permissions;

const memoizedSurveyTypePermissions = createSelector(selectPermissions(), (permissions) => permissions?.surveyTypes);

const selectSurveyTypePermissions = () => memoizedSurveyTypePermissions;

const memoizedSurveyTypePermission = createSelector(
  selectPermissions(),
  (_: ReduxStore, surveyTypeId?: number) => surveyTypeId,
  (permissions, surveyTypeId) => {
    return surveyTypeId ? permissions?.surveyTypes[surveyTypeId] : undefined;
  },
);

const selectSurveyTypePermission = (surveyTypeId?: number) => (state: ReduxStore) => {
  return memoizedSurveyTypePermission(state, surveyTypeId);
};

const memoizedPermittedSurveyTypeIds = createSelector(selectPermissions(), (permissions) =>
  Object.keys(permissions?.surveyTypes || {}),
);

const selectPermittedSurveyTypeIds = () => memoizedPermittedSurveyTypeIds;

export const permissionSelectors = {
  selectPermissions,
  selectSurveyTypePermission,
  selectSurveyTypePermissions,
  selectPermittedSurveyTypeIds,
};
